package com.wintermar.inspection.feature.presentation.template.landing

sealed class TemplateLandingEvent {
    data class NavigateToInspectionAnswer(val inspectionId: String) : TemplateLandingEvent()
}
